import { FormControl, Grid, IconButton, InputLabel, Select, TextField, Autocomplete
    , Typography, Stack, Box, Checkbox, FormControlLabel } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { init, setEntity, setData, setValidationMessage, activeValidations
  , setListAreaObjetivo, defaultEntity} from "../redux/areaObjectiveCriterionSlice";
import { FormHelperText as HelperText } from '@mui/material';

const AreaObjectiveCriterion = (props) => {
    const isReadOnly = props.isReadOnly;
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(init({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
        const timer = setTimeout(() => inputRef.current?.focus(), 150);
        return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const entity = useSelector((state) => state.areaObjectiveCriterion[sliceKey].entity);
    const listAreaObjetivo = useSelector((state) => state.areaObjectiveCriterion[sliceKey].listAreaObjetivo);
    const validate = useSelector((state) => state.areaObjectiveCriterion[sliceKey].validationActive);

    var validation = {
        idAreaObjetivo: {
            error: entity.idAreaObjetivo == 0 || entity.idAreaObjetivo == null,
            message: "Falta ingresar el objetivo",
        },
        descripcion: {
            error: entity.descripcion.length < 1,
            message: "Falta ingresar la descripción del criterio",
        },
        orden: {
            error: entity.orden < 0,
            message: "Ingrese un número de orden válido",
        },
    }

    const fetchEntity = useCallback(async () => {
        const response = await api.get("/Modelo/GetAreaObjetivoCriterio?idAreaObjetivoCriterio=" + props.id)
            .catch((err) => {
                console.log("Err: ", err);
            });

        if (props.id == 0){
            dispatch(setEntity({sliceKey: sliceKey, data: defaultEntity}));
            console.log(props.idAreaObjetivo)
            console.log(props.areaObjetivo)
            dispatch(setData({sliceKey: sliceKey, name: "idAreaObjetivo", value: props.idAreaObjetivo}));
            dispatch(setData({sliceKey: sliceKey, name: "objetivo", value: props.areaObjetivo}));
        }
        else {
            dispatch(setEntity({sliceKey: sliceKey, data: response.data.data}));
        }
    }, [])
    const fetchAreaObjetivo = useCallback(async () => {
        const response = await api.get("/Modelo/GetsListAreaObjetivo?idArea=" + props.idArea)
            .catch((err) => {
                console.log("Err: ", err);
            });

        console.log(response.data.data)

        dispatch(setListAreaObjetivo({sliceKey: sliceKey, data: response.data.data}));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchAreaObjetivo();
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(listAreaObjetivo)} */}
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={8} sm={4}>
                    {/* <FormControl required fullWidth error={validate?.idAreaObjetivo && validation.idAreaObjetivo.error}>
                        <InputLabel htmlFor="input-areaobjetivo">Objetivo</InputLabel>
                        <Select
                            native
                            label="Objetivo"
                            value={entity?.idAreaObjetivo}
                            onChange={(event) => {
                                var id = event.nativeEvent.target.selectedIndex;
                                
                                console.log(event.target.value)
                                console.log(event.nativeEvent.target[id].text)

                                dispatch(setData({sliceKey: sliceKey, name: "idAreaObjetivo", value: event.target.value}))
                                dispatch(setData({sliceKey: sliceKey, name: "objetivo", value: event.nativeEvent.target[id].text}))
                            }}
                            inputProps={{
                                name: 'idAreaObjetivo',
                                id: 'input-areaobjetivo',
                            }}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listAreaObjetivo?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate?.idAreaObjetivo && validation.idAreaObjetivo.error ? validation.idAreaObjetivo.message : ""}
                        </HelperText>
                    </FormControl> */}
                    <FormControl required fullWidth>
                        <Autocomplete
                            name="idAreaObjetivo"
                            value={listAreaObjetivo.find(x => x.id === entity.idAreaObjetivo) || null}
                            inputValue={entity.objetivo || ""}
                            onInputChange={(event, newValue) => {
                                if (event != null) {
                                    if (event.type === "change") {
                                        dispatch(setData({sliceKey: sliceKey, name: "areaObjetivo", value: newValue || ""}))
                                        // dispatch(setData({name: "colegio", value: newValue || ""}))
                                    }
                                }
                            }}
                            onChange={(event, newValue) => {
                                dispatch(setData({sliceKey: sliceKey, name: "idAreaObjetivo", value: newValue?.id ?? 0}))
                                dispatch(setData({sliceKey: sliceKey, name: "objetivo", value: newValue?.descripcion ?? ""}))
                                // dispatch(setData({name: "idColegio", value: newValue?.id ?? 0}))
                                // dispatch(setData({name: "colegio", value: newValue?.descripcion ?? ""}))
                            }}
                            options={listAreaObjetivo}
                            autoHighlight
                            disabled={isReadOnly}
                            getOptionLabel={(option) => option.descripcion || ""}
                            isOptionEqualToValue ={(option, value) => option.value === value.value}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                    {option.descripcion}
                                    </li>
                                );
                                }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="AreaObjetivo"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                    }}
                                />
                            )}
                            size="small"
                        />
                        {/* <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={4} sm={1}>
                    <TextField
                        required
                        name="valor"
                        label="Valor"
                        type='number'
                        fullWidth
                        value={entity?.valor}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <TextField
                        name="descripcion"
                        label="Descripción"
                        fullWidth
                        value={entity?.descripcion}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={4} sm={1}>
                    <TextField
                        name="orden"
                        label="Orden"
                        type='number'
                        fullWidth
                        value={entity?.orden}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
export default AreaObjectiveCriterion;
